import gql from 'graphql-tag'

export const MutationUpdatePreferences = gql(`mutation update_preferences($lang: String, $state: AWSJSON) {
    updatePreferences(lang: $lang, state: $state) {
      user_id
      lang
      state
    }
  }`)

export const MutationUpdatePreferencesFromCache = gql(`mutation update_preferences($lang: String, $state: AWSJSON) {
    updatePreferences(lang: $lang, state: $state) @client {
      user_id
      lang
      state
    }
  }`)



// WEBPACK FOOTER //
// ./src/graphql/MutationUpdatePreferences.js